export default __webpack_public_path__ + "static/media/g12.059ffd2d.jpg";